const ProjectionBoostRule = {
    PROJECTION_BOOST_RULE_SET_DATA_FROM_STORAGE: 'PROJECTION_BOOST_RULE_SET_DATA_FROM_STORAGE',
    PROJECTION_BOOST_RULE_SET_IS_USED: 'PROJECTION_BOOST_RULE_SET_IS_USED',
    PROJECTION_BOOST_RULE_ADD_ITEM: 'PROJECTION_BOOST_RULE_ADD_ITEM',
    PROJECTION_BOOST_RULE_REMOVE_ITEM: 'PROJECTION_BOOST_RULE_REMOVE_ITEM',
};

export default ProjectionBoostRule;
